import { ChevronRight } from 'lucide-react'
import './caret.css'

/**
 * What folding a listing's branch does, in the one wording every listing uses
 * — a table's tree and its cards alike.
 */
export const foldLabel = (shut: boolean, branch: string) =>
  `${shut ? 'Show' : 'Hide'} what is under ${branch}`

/**
 * The control that opens and shuts a branch — the app's one fold.
 *
 * Every tree in the app folds the same way because there is one of these: the
 * contents rail beside a book and a listing whose rows carry a parent are the
 * same gesture on two surfaces, and a second caret written beside this one is
 * how they come to rotate differently, announce differently, or ignore a
 * reader who has asked for no motion.
 *
 * It carries `data-no-open`, so folding a branch inside a row that opens a
 * record does not also open it (see `opensRecord`).
 */
export function Caret({
  expanded,
  label,
  onToggle,
  size = 13,
}: {
  expanded: boolean
  /** What folding this does, naming the branch — "Show what is in Bereishis". */
  label: string
  onToggle: () => void
  size?: number
}) {
  return (
    <button
      type="button"
      className="caret"
      data-no-open
      aria-expanded={expanded}
      aria-label={label}
      onClick={onToggle}
    >
      <ChevronRight size={size} />
    </button>
  )
}
